import { Button } from '@mui/material';

import useSettings from '../hooks/useSettings';
import ResponsiveDialog from '../dialogs/ResponsiveDialog';
import QueryBuilder from './QueryBuilder';

interface QueryBuilderDialogProps {
	/** True to show this dialog, false to hide it */
	open: boolean;
	/** Function used to close the dialog */
	closeDialog: () => void;
	/** The displayed query value */
	currentQuery: any;
	/** The displayed query tree */
	currentTree: any;
	/** The QueryBuilder config */
	queryConfig: any;
	/** Function used to clear the query value*/
	handleQueryClear: () => void;
	/** Function used to change the current query value */
	handleQueryChange: (newTree: any, conf: any) => void;
	/** Function used to set the current query value to the query */
	handleQueryApply: () => void;
	/** Used to show the clear button */
	showClear?: boolean;
}

/** A dialog that show a query builder for a specified module */
export default function QueryBuilderDialog({
	open,
	closeDialog,
	currentQuery,
	currentTree,
	queryConfig,
	handleQueryClear,
	handleQueryChange,
	handleQueryApply,
	showClear = true
}: QueryBuilderDialogProps) {
	const { t } = useSettings();

	const handleClear = () => {
		handleQueryClear();
		closeDialog();
	};

	const handleApply = () => {
		handleQueryApply();
		closeDialog();
	};

	return (
		<ResponsiveDialog
			open={open}
			onClose={closeDialog}
			maxWidth="md"
			title={t('DIALOG_TITLE_QUERY_BUILDER')}
			content={
				<QueryBuilder
					currentTree={currentTree}
					queryConfig={queryConfig}
					handleQueryChange={handleQueryChange}
				/>
			}
			actions={
				<>
					<Button onClick={closeDialog}>{t('DIALOG_ACTION_BACK')}</Button>
					{showClear && <Button onClick={handleClear}>{t('DIALOG_ACTION_CLEAR')}</Button>}
					<Button onClick={handleApply} color="secondary" disabled={!currentQuery}>
						{t('DIALOG_ACTION_APPLY')}
					</Button>
				</>
			}
		/>
	);
}
